export default __webpack_public_path__ + "static/media/124-wind-chime.112d5d8a.jpeg";